// Без VITE_MARKETING_SITE: на DEV (profile.dev.myteacher.pro) ведём на myteacher.dev.myteacher.pro, на проде - myteacher.pro.
const runtimeMarketingOrigin = (): string => {
  if (typeof window === 'undefined') return 'https://myteacher.pro';
  const host = window.location.hostname;
  if (/\.dev\.myteacher\.pro$/.test(host)) return 'https://myteacher.dev.myteacher.pro';
  return 'https://myteacher.pro';
};

const MARKETING_ORIGIN = (
  import.meta.env.VITE_MARKETING_SITE || runtimeMarketingOrigin()
).replace(/\/$/, '');

export const marketingHref = (path: string) => `${MARKETING_ORIGIN}${path}`;

export const marketingLinks = {
  home: MARKETING_ORIGIN,
  terms: `${MARKETING_ORIGIN}/Terms`,
  privacy: `${MARKETING_ORIGIN}/privacy`,
  privacyConsent: `${MARKETING_ORIGIN}/privacy/consent`,
  questions: `${MARKETING_ORIGIN}/Questions`,
  categories: `${MARKETING_ORIGIN}/categories`,
  about: `${MARKETING_ORIGIN}/about`,
  guides: `${MARKETING_ORIGIN}/guides`,
  probniyUrok: `${MARKETING_ORIGIN}/probniy_urok`,
} as const;
